/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
    AccountToJSONTyped,
} from './Account';

/**
 * 
 * @export
 * @interface Post
 */
export interface Post {
    /**
     * Unique identifier for the post
     * @type {string}
     * @memberof Post
     */
    readonly id: string;
    /**
     * Text content of the post
     * @type {string}
     * @memberof Post
     */
    text?: string;
    /**
     * URL of the post image
     * @type {string}
     * @memberof Post
     */
    imageUrl?: string;
    /**
     * Type of entity this post is about
     * @type {string}
     * @memberof Post
     */
    postableType: PostPostableTypeEnum;
    /**
     * ID of the entity this post is about
     * @type {string}
     * @memberof Post
     */
    postableId: string;
    /**
     * Timestamp when the post was created
     * @type {Date}
     * @memberof Post
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the post was last updated
     * @type {Date}
     * @memberof Post
     */
    readonly updatedAt: Date;
    /**
     * Account that created this post
     * @type {Account}
     * @memberof Post
     */
    readonly account: Account;
    /**
     * ID of the account that created this post
     * @type {string}
     * @memberof Post
     */
    readonly accountId: string;
    /**
     * File associated with this post
     * @type {any}
     * @memberof Post
     */
    readonly file?: any;
    /**
     * ID of the file associated with this post
     * @type {string}
     * @memberof Post
     */
    readonly fileId?: string;
}


/**
 * @export
 */
export const PostPostableTypeEnum = {
    Itinerary: 'itinerary',
    Stop: 'stop'
} as const;
export type PostPostableTypeEnum = typeof PostPostableTypeEnum[keyof typeof PostPostableTypeEnum];


/**
 * Check if a given object implements the Post interface.
 */
export function instanceOfPost(value: object): value is Post {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('postableType' in value) || value['postableType'] === undefined) return false;
    if (!('postableId' in value) || value['postableId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('account' in value) || value['account'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    return true;
}

export function PostFromJSON(json: any): Post {
    return PostFromJSONTyped(json, false);
}

export function PostFromJSONTyped(json: any, ignoreDiscriminator: boolean): Post {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'text': json['text'] == null ? undefined : json['text'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'postableType': json['postableType'],
        'postableId': json['postableId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'account': AccountFromJSON(json['account']),
        'accountId': json['accountId'],
        'file': json['file'] == null ? undefined : json['file'],
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
    };
}

  export function PostToJSON(json: any): Post {
      return PostToJSONTyped(json, false);
  }

  export function PostToJSONTyped(value?: Omit<Post, 'id'|'createdAt'|'updatedAt'|'account'|'accountId'|'file'|'fileId'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'imageUrl': value['imageUrl'],
        'postableType': value['postableType'],
        'postableId': value['postableId'],
    };
}

